export const breadcrumbs = [
  {
    text: "Главная",
    disabled: false,
    href: "/",
  },
  {
    text: "Справочники: Перечень видов документов - реестр видов документов",
    disabled: true,
    href: "breadcrumbs_link_1",
  },
];
